import styled from "styled-components";
import { Droppable } from "react-beautiful-dnd";
import { abc } from "../../../../constants/abc";
import { Trash, Plus, ListPlus } from "phosphor-react";
import Category from "./Category";
import { useFirestore } from "react-redux-firebase";
import { v4 } from "uuid";
import { kitSizes } from "../../constants";

import Item from "./Item";

const Container = styled.div`
  margin-bottom: 30px;
`;

const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: grey;
  padding-bottom: 10px;
  position: relative;
`;

const KitName = styled.div`
  background: white;
  padding-right: 10px;
  z-index: 1;
`;

const Line = styled.div`
  border-top: 1px solid grey;
  flex-grow: 1;
  margin-left: 20px;
  position: absolute;
  left: 0;
  width: 95%;
  z-index: 0;
`;

const KitSize = styled.select`
  border: 2px solid grey;
  font-weight: 700;
  color: grey;
  display: flex;
  justify-content: center;
  padding: 3px;
  border-radius: 3px;
  cursor: pointer;
  background: white;
  text-transform: uppercase;
  z-index: 1;
`;

const List = styled.div``;

const AddItem = styled.div`
  display: flex;
  border: 1px solid grey;
  align-items: center;
  color: grey;
  padding: 3px;
  cursor: pointer;
  width: max-content;
  border-radius: 3px;

  &:hover {
    background: grey;
    color: white;
  }
`;

const DeleteKit = styled.div`
  border: 1px solid grey;
  color: grey;
  display: flex;
  justify-content: center;
  padding: 3px;
  border-radius: 3px;
  background: white;
  cursor: pointer;
  &:hover {
    background: grey;
    color: white;
  }
  z-index: 1;
`;

const Add = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

const Row = ({
  kit,
  i: kitIndex,
  deleteItem,
  handleTax,
  editCategoryItem,
  addItemToCategory,
  deleteCategoryItem,
  handleCategoryItemTax,
  doc,
  storedDocuments,
  setStoredDocuments,
  color,
  prices,
}) => {
  const firestore = useFirestore();

  const addItem = (doc, i) => {
    let docs = [...storedDocuments];
    docs[docs.indexOf(doc)].kits[i].items.push({
      title: "",
      amount: 0,
      tax: true,
      id: v4(),
    });
    setStoredDocuments(docs);
    return firestore.update(
      { collection: "client-documents", doc: doc.id },
      docs[docs.indexOf(doc)]
    );
  };

  const editKit = (key, value, kitIndex) => {
    let docs = [...storedDocuments];
    docs[docs.indexOf(doc)].kits[kitIndex][key] = value;
    setStoredDocuments(docs);
    return firestore.update(
      { collection: "client-documents", doc: doc.id },
      docs[docs.indexOf(doc)]
    );
  };

  const deleteKit = (kitIndex) => {
    if (window.confirm("You sure you want to delete this kit?")) {
      let docs = [...storedDocuments];
      docs[docs.indexOf(doc)].kits.splice(kitIndex, 1);
      setStoredDocuments(docs);
      return firestore.update(
        { collection: "client-documents", doc: doc.id },
        docs[docs.indexOf(doc)]
      );
    }
  };

  const addItemCategory = (kitIndex) => {
    let docs = [...storedDocuments];
    docs[docs.indexOf(doc)].kits[kitIndex].items.push({
      title: "",
      amount: 0,
      tax: true,
      category: [{ title: "", amount: 0, tax: true }],
    });
    setStoredDocuments(docs);
    return firestore.update(
      { collection: "client-documents", doc: doc.id },
      docs[docs.indexOf(doc)]
    );
  };

  console.log(kit.size);

  return (
    <Container>
      <Title>
        <KitName>Kit {abc[kitIndex]}</KitName>
        <KitSize
          placeholder={kit.size}
          onChange={(e) => editKit("size", e.target.value, kitIndex)}
        >
          <option>select size</option>
          {prices.sort().map((kitPrice, priceIndex) => (
            <option
              key={priceIndex}
              value={kitPrice.title}
              selected={kitPrice.title === kit.size}
            >
              {kitPrice.title} {kitSizes[kitPrice.title.toLowerCase()]}
            </option>
          ))}
        </KitSize>

        <DeleteKit onClick={() => deleteKit(kitIndex)}>
          <Trash />
        </DeleteKit>
        <Line></Line>
      </Title>
      <Droppable droppableId={kit.id}>
        {(provided) => (
          <List
            ref={provided.innerRef}
            innerRef={provided.innerRef}
            {...provided.droppableProps}
          >
            {kit.items.map((item, itemIndex) =>
              typeof item.category === "undefined" ? (
                <Item
                  key={itemIndex}
                  item={item}
                  index={itemIndex}
                  doc={doc}
                  addItem={addItem}
                  kitIndex={kitIndex}
                  kit={kit}
                  storedDocuments={storedDocuments}
                  setStoredDocuments={setStoredDocuments}
                  color={color}
                  prices={prices}
                />
              ) : (
                <Category
                  key={itemIndex}
                  item={item}
                  categoryIndex={itemIndex}
                  doc={doc}
                  kit={kit}
                  deleteItem={deleteItem}
                  handleTax={handleTax}
                  addItem={addItem}
                  kitIndex={kitIndex}
                  editCategoryItem={editCategoryItem}
                  addItemToCategory={addItemToCategory}
                  deleteCategoryItem={deleteCategoryItem}
                  handleCategoryItemTax={handleCategoryItemTax}
                  storedDocuments={storedDocuments}
                  setStoredDocuments={setStoredDocuments}
                  color={color}
                  prices={prices}
                />
              )
            )}
            {provided.placeholder}
          </List>
        )}
      </Droppable>
      <Add>
        <AddItem onClick={() => addItem(doc, kitIndex)}>
          <Plus />
        </AddItem>
        <AddItem onClick={() => addItemCategory(kitIndex)}>
          <ListPlus />
        </AddItem>
      </Add>
    </Container>
  );
};

export default Row;
